module.exports = __webpack_public_path__ + "static/media/dumbbell.a3b06cc1.svg";